module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-image-db71d51b.svg";